"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DomainEvent_1 = require("../Engine/Event/DomainEvent");
const SessionDefinition_1 = require("./SessionDefinition");
class SessionEvent {
    static InvitationSentEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.InvitationSent,
            entityId: st.id,
            body: st
        });
    }
    static InvitationReceivedEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.InvitationReceived,
            entityId: st.id,
            body: st
        });
    }
    static InvitationRejectedEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.InvitationRejected,
            entityId: st.id,
            body: st
        });
    }
    static InvitationCanceledEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.InvitationCanceled,
            entityId: st.id,
            body: st
        });
    }
    static LinkWithAttendeeWasInitedEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.LinkWithAttendeeWasInited,
            entityId: st.id,
            body: st
        });
    }
    static LinkWithAttendeeWasUpEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.LinkWithAttendeeWasUp,
            entityId: st.id,
            body: st
        });
    }
    static LinkWithAttendeeWasDownEvent(sessionAttendee) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.LinkWithAttendeeWasDown,
            entityId: sessionAttendee.Item1.id,
            body: sessionAttendee
        });
    }
    static LinkWithAttendeePacketLossPercentChangedEvent(sessionAttendeePacketLoss) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.LinkWithAttendeePacketLossPercentChanged, entityId: sessionAttendeePacketLoss.Item1.id,
            body: sessionAttendeePacketLoss,
        });
    }
    static SessionFailedEvent(stAttendeeStatusReason) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.SessionFailed,
            entityId: stAttendeeStatusReason.Item1.id,
            body: stAttendeeStatusReason
        });
    }
    static SessionTerminatedEvent(st) {
        return new DomainEvent_1.DomainEvent({
            version: SessionEvent.Version,
            category: SessionEvent.Category,
            name: SessionEvent.SessionTerminated,
            entityId: st.id,
            body: st
        });
    }
}
SessionEvent.Version = SessionDefinition_1.SessionVersion;
SessionEvent.Category = SessionDefinition_1.SessionEventCategory;
SessionEvent.InvitationSent = "InvitationSent";
SessionEvent.InvitationReceived = "InvitationReceived";
SessionEvent.InvitationRejected = "InvitationRejected";
SessionEvent.InvitationCanceled = "InvitationCanceled";
SessionEvent.LinkWithAttendeeWasInited = "LinkWithAttendeeWasInited";
SessionEvent.LinkWithAttendeeWasUp = "LinkWithAttendeeWasUp";
SessionEvent.LinkWithAttendeeWasDown = "LinkWithAttendeeWasDown";
SessionEvent.LinkWithAttendeePacketLossPercentChanged = "LinkWithAttendeePacketLossPercentChanged";
SessionEvent.SessionFailed = "SessionFailed";
SessionEvent.SessionTerminated = "SessionTerminated";
exports.SessionEvent = SessionEvent;
//# sourceMappingURL=SessionEvent.js.map